export const firebaseConfig = {
  apiKey: 'AIzaSyD9_ir3aH9B6_e6_ApLybGI7FlCrUNLj7c',
  authDomain: 'guara-burguer.firebaseapp.com',
  projectId: 'guara-burguer',
  storageBucket: 'guara-burguer.appspot.com',
  messagingSenderId: '938080559416',
  appId: '1:938080559416:web:685eadc5db29aad29021cd',
  measurementId: 'G-3ZEELQ1BV2',
};
